// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3-_0Q","content":"styles_content__30i6Q","selectAll":"styles_selectAll__Iafsa"};